import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCallFile } from "../../../utils/service";

export const downloadData = async (
  profileId: string,
  selectedDataTypes: string[],
  language: string,
  format: string = "zip"
) => {
  try {
    const body = {
      profileId: profileId,
      dataList: selectedDataTypes,
      language: language,
      download: format,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(urls.dataDownloadApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
